import EventEmitter from '../utils/event-emitter.js';
import replaceVariables from '../utils/replace-variables.js';
export default class RunnableTranslateFunction extends EventEmitter {
    #fallbackTranslations;
    #translations;
    constructor({ fallbackTranslations, translations }) {
        super();
        this.#fallbackTranslations = fallbackTranslations;
        this.#translations = translations;
        this.run = this.run.bind(this);
    }
    run(str, vars) {
        if (typeof this.#translations === 'undefined') {
            this.emit('loadTranslations', str);
            return;
        }
        const translationsStr = this.#translations[str];
        if (typeof translationsStr !== 'undefined') {
            return replaceVariables(translationsStr, vars);
        }
        if (typeof this.#fallbackTranslations === 'undefined') {
            this.emit('loadFallbackTranslations', str);
            return;
        }
        const fallbackTranslationsStr = this.#fallbackTranslations[str];
        if (typeof fallbackTranslationsStr !== 'undefined') {
            return replaceVariables(fallbackTranslationsStr, vars);
        }
        this.emit('notFound', str);
        return;
    }
}
//# sourceMappingURL=runnable-translate-function.js.map